import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../../pages/listings.module.css';
import { truncate } from '../../utils/utils';

const ItemsTable = ({ items }) => {
  const navigate = useNavigate();

  return (
    <>
      <table className='table table-striped table-hover'>
        <thead>
          <tr className={`${styles.headings}`}>
            <th scope='col'>#</th>
            <th scope='col'>Description</th>
            <th scope='col'>Brand</th>
            <th scope='col'>Model</th>
            <th scope='col'>Quantity</th>
            <th scope='col'>Unit</th>
            <th scope='col'>Price</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, idx) => (
              <tr key={item.id} className={styles.rows}>
                <th scope='row'>{idx + 1}</th>
                <td>{truncate(item.description, 20)}</td>
                <td>{item.brand}</td>
                <td>{item.model}</td>
                <td>{item.quantity}</td>
                <td>{item.unit}</td>
                <td>{item.price}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7}>No items to display ...</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default ItemsTable;
